import type { Paginated } from "./platform-api";

/** The API's largest page (PaginationDto `@Max(200)`); anything bigger is a 400. */
export const MAX_PAGE_SIZE = 200;

/**
 * Read every page of a paginated list. For pickers and lookups that need the
 * whole set — a single `pageSize: 200` call silently drops row 201 onwards.
 * Stops on a short page, at the reported total, or after `maxPages`.
 */
export async function fetchAllPages<T>(
  fetchPage: (page: number, pageSize: number) => Promise<Paginated<T>>,
  { pageSize = MAX_PAGE_SIZE, maxPages = 100 }: { pageSize?: number; maxPages?: number } = {},
): Promise<T[]> {
  const rows: T[] = [];
  for (let page = 1; page <= maxPages; page++) {
    const res = await fetchPage(page, pageSize);
    rows.push(...res.data);
    if (res.data.length < pageSize || rows.length >= res.total) break;
  }
  return rows;
}
